import { useGetVisaTypesQuery } from "@codegen/index";
import { formatVisaClass } from "@utils/parsers";
import { useMemo } from "react";
import { Combobox } from "./combobox";

const VisaClassSelector = (props: {
  selectedType?: string;
  onSelect?: (type: string) => void;
  className?: string;
  disabled?: boolean;
}) => {
  const { selectedType, onSelect, disabled, className } = props;
  const { data: visaTypesData } = useGetVisaTypesQuery();

  const visaClassValues = useMemo(() => {
    const res = [];

    if (visaTypesData?.allVisaTypes?.nodes) {
      for (const node of visaTypesData.allVisaTypes.nodes) {
        if (node?.visaTypeCode) {
          const normalizedCode = formatVisaClass(node.visaTypeCode);
          res.push({
            value: node.visaTypeCode,
            label: normalizedCode,
          });
        }
      }
    }

    // force display for builder/header.tsx
    res.push({
      value: selectedType ?? "",
      label: selectedType ?? "",
    });

    return res;
  }, [selectedType, visaTypesData]);

  return (
    <Combobox
      options={visaClassValues}
      defaultValue={selectedType ?? ""}
      onSelect={(e) => onSelect?.(e)}
      placeholder="Search visa type"
      className={className}
      disabled={disabled}
    />
  );
};

export default VisaClassSelector;
